var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input-file-base',{staticClass:"input-file",on:{"change":_vm.changeEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }